/**
 * Created by Administrador on 22/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('fareSubClassificationService', fareSubClassificationService)

    fareSubClassificationService.$inject = ['$http', 'CONFIG', 'messageService'];

    function fareSubClassificationService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CARGO_CONTROL + '/' + CONFIG.API + '/fareSubClassifications';
        var service = {
            getFareSubClassifications: getFareSubClassifications,
            getFareSubClassificationList: getFareSubClassificationList,
            getFareSubClassification: getFareSubClassification,
            getFareSubClasBySubClassId: getFareSubClasBySubClassId,
            saveFareSubClassification: saveFareSubClassification,
            updateFareSubClassification: updateFareSubClassification,
            deleteFareSubClassification: deleteFareSubClassification
        }

        return service;

        function getFareSubClassifications(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getFareSubClassificationList(){
            return $http.get(urlBase + '/list?detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getFareSubClassification(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('fareSubClassifications')
                });
        }

        function getFareSubClasBySubClassId(id){
            return $http.get(urlBase + '/list/'+id+'/subClassification')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function saveFareSubClassification(fareSubClassification){
            return $http.post(urlBase, fareSubClassification)
                .then(function(response){
                    messageService.register('subClassifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('subClassifications')
                });
        }

        function updateFareSubClassification(fareSubClassificationId, fareSubClassification){
            return $http.put(urlBase + "/" + fareSubClassificationId, fareSubClassification)
                .then(function(response){
                    messageService.registerUpdate('subClassifications')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('subClassifications')
                });
        }

        function deleteFareSubClassification(fareSubClassificationId){
            return $http.delete(urlBase + "/" + fareSubClassificationId)
                .then(function(response){
                    messageService.registerDelete('subClassifications');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('subClassifications');
                });
        }
    }
})();
